import * as React from "react";
import Link from "./Link";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/pro-solid-svg-icons";

type NavigationItem = {
    label: string
    to: string
    end?: boolean
    disabled?: boolean
    disabledTooltip?: string
}

type SecondaryNavigationProps = {
    items: Array<NavigationItem>
}

const SecondaryNavigation: React.FC<SecondaryNavigationProps> = ({items}) => {
    const regularClassName = "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm uppercase"
    const activeClassName = "border-red-500 hover:border-red-400 text-red-600 hover:text-red-500 whitespace-nowrap py-4 px-1 border-b-4 font-medium text-sm"
    const disabledClassName = "border-transparent text-gray-300 cursor-not-allowed whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm uppercase"

    return (
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                {items.map((item, index) => (
                    item.disabled ? (
                        <span
                            key={index}
                            className={disabledClassName}
                            title={item.disabledTooltip}
                        >
                            {item.label}
                            <FontAwesomeIcon icon={faLock} className="ml-1.5 h-3 w-3" />
                        </span>
                    ) : (
                        <Link key={index} to={item.to} activeClassName={activeClassName} className={regularClassName} end={item.end}>
                            {item.label}
                        </Link>
                    )
                ))}
            </nav>
        </div>
    )
}

export default SecondaryNavigation;
